export enum Roles
{
    Admin = "Администратор",
    Applicant = "Applicant",
    Monitoring = "Monitoring",
    Operator = "Оператор"
}
